module.exports = __webpack_public_path__ + "img/slider_galery_6.6f7228fe.jpg";